import React from 'react';
import Slider, { Settings as SlickSettings } from 'react-slick';

import img1 from './images/1.jpg';
import img2 from './images/2.jpg';
import img3 from './images/3.jpg';
import img4 from './images/4.jpg';
import img6 from './images/6.jpg';
import img7 from './images/7.jpg';
import img8 from './images/8.jpg';
import img9 from './images/9.jpg';
import img10 from './images/10.jpg';
import img11 from './images/11.jpg';
import img12 from './images/12.jpg';
import img13 from './images/13.jpg';
import img14 from './images/14.jpg';
import img15 from './images/15.jpg';
import img16 from './images/16.jpg';
import img17 from './images/17.jpg';
import img18 from './images/18.jpg';
import img19 from './images/19.jpg';
import img20 from './images/20.jpg';
import img21 from './images/21.jpg';
import img22 from './images/22.jpg';

import './IQCImageCarousel.scss';

interface IQCImageCarouselProps {}

const images: string[] = [
  img1,
  img2,
  img3,
  img4,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18,
  img19,
  img20,
  img21,
  img22,
];

const carouselSettings: SlickSettings = {
  infinite: true,
  speed: 500,
  variableWidth: true,
  adaptiveHeight: true,
  swipeToSlide: true,
  autoplay: true,
  autoplaySpeed: 5000,
  responsive: [
    {
      breakpoint: 768,
      settings: { dots: true, arrows: false },
    },
  ],
};

export function IQCImageCarousel(_props: IQCImageCarouselProps) {
  return (
    <div className="iqcCarousel__container">
      <Slider {...carouselSettings}>
        {images.map((image, index) => (
          <div key={`slide-${index}`} className="iqcCarousel__slide">
            <img src={image} alt={`IQC 2023 - ${index}`} />
          </div>
        ))}
      </Slider>
    </div>
  );
}
